import HandoverChecklistImage from "../assets/images/articles/handover-checklist.webp";
import PropertyManagementImage from "../assets/images/articles/property-management.webp";
import InheritancePlanningImage from "../assets/images/articles/inheritance-planning.webp";
import RentalManagementImage from "../assets/images/articles/rental-management.webp";
import BankAccountInDubaiImage from "../assets/images/articles/bank-account-in-dubai-mobile.webp";
// import AppraisalImage from "../assets/images/articles/appraisal.webp";

export interface Article {
  id: number;
  image: string;
  titleKey: string;
  descriptionKey: string;
  tags: string[];
}

export const ARTICLES: Article[] = [
  {
    id: 1,
    image: HandoverChecklistImage,
    titleKey: "articles.handover_checklist.title",
    descriptionKey: "articles.handover_checklist.subtitle",
    tags: ["construction", "handover"],
  },
  {
    id: 2,
    image: RentalManagementImage,
    titleKey: "articles.rental_management.title",
    descriptionKey: "articles.rental_management.subtitle",
    tags: ["vacant", "ready"],
  },
  {
    id: 3,
    image: PropertyManagementImage,
    titleKey: "articles.find_tenant.title",
    descriptionKey: "articles.find_tenant.subtitle",
    tags: ["vacant", "ready"],
  },
  {
    id: 4,
    image: InheritancePlanningImage,
    titleKey: "articles.inheritance_planning.title",
    descriptionKey: "articles.inheritance_planning.subtitle",
    tags: ["finance", "ready", "rented"],
  },
  {
    id: 5,
    image: BankAccountInDubaiImage,
    titleKey: "articles.bank_account.title",
    descriptionKey: "articles.bank_account.subtitle",
    tags: ["finance", "ready", "rented"],
  },
  /*{
    id: 6,
    image: AppraisalImage,
    titleKey: "articles.appraisal.title",
    descriptionKey: "articles.appraisal.subtitle",
    tags: ["handover", "ready", "services", "rental_management"],
  },*/
];
